import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiHelpCircle } from 'react-icons/fi';
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';

const CheckoutHelpBox = ({ showDisclaimer = true }) => {
  const { t } = useTranslation(['shipping', 'cart']);
  const { assignedLibrary } = useAssignedLibrary();

  return (
    <aside className="checkout-help">
      <FiHelpCircle className="checkout-help__icon" aria-hidden="true" />
      <div className="checkout-help__content">
        <p className="checkout-help__text">
          {t('anyDoubts', { ns: 'shipping' })}{' '}
          <Link to={`/${assignedLibrary}/faqs`}>{t('faq', { ns: 'shipping' })}</Link>{' '}
          {t('or', { ns: 'shipping' })}{' '}
          <Link to={`/${assignedLibrary}/contacto`}>{t('contactUs', { ns: 'shipping' })}</Link>.
        </p>
        {showDisclaimer && (
          <p className="checkout-help__disclaimer">{t('formFullfilmentResponsability', { ns: 'shipping' })}</p>
        )}
      </div>
    </aside>
  );
};

CheckoutHelpBox.propTypes = {
  showDisclaimer: PropTypes.bool,
};

export default CheckoutHelpBox;
